import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

import { ProtectionForRouteService } from 'app/components/common/protected-route/protection-for-route-service';
import { Protection } from 'app/components/common/protected-route/protection';

interface OwnProps {
    protections: Protection[];
    component: Required<RouteProps>['component'];
}

export type ProtectedRouteProps = OwnProps & Omit<RouteProps, 'component'>;

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props) => {
    const { component: Component, protections, ...rest } = props;

    return (
        <Route
            {...rest}
            render={(componentProps) =>
                ProtectionForRouteService.isProtectedRoute(protections, componentProps) ? (
                    <Redirect to={ProtectionForRouteService.getRedirectUrl(protections, componentProps)} />
                ) : (
                    <Component {...componentProps} />
                )
            }
        />
    );
};

export { ProtectedRoute };
